import styles from './index.scss'
const DpRichText = (props: any) => {
  const { data, ...resProps } = props
  if (!data) return <></>
  return (
    <div
      className={`${styles['dp-RichText']} ${props?.className || ''}`}
      {...resProps}
      dangerouslySetInnerHTML={{ __html: data }}
      aria-live="polite"
    />
  )
}
export default DpRichText
